import React from 'react';
import { Link } from 'react-router-dom';

const TAIL_SLUGS = new Set([
  'barnstaple',
  'bideford',
  'south-molton',
  'padstow',
  'newquay',
  'st-ives'
]);

export default function LocalAreaTailSection({ slug }) {
  const key = String(slug || '').toLowerCase();
  if (!TAIL_SLUGS.has(key)) return null;

  return (
    <section className="mt-10 pt-8 border-t border-gray-200" aria-labelledby={`local-economy-${key}`}>
      <h2 id={`local-economy-${key}`} className="text-xl font-bold text-gray-900 mb-4">
        Local economy
      </h2>
      <div className="space-y-4 text-gray-700 leading-relaxed">
        {key === 'barnstaple' && (
          <>
            <p>
              As the premier commercial center for North Devon, Barnstaple requires a digital presence that stands out in a competitive EX31 and EX32 landscape. From the heritage-rich Pannier Market traders to the modern retail presence at Green Lanes, we provide high-performance web design that captures local footfall. Whether you are a service provider in Roundswell Business Park or a boutique on the High Street, our &apos;Free Build&apos; model ensures your Barnstaple business dominates the local search map without the heavy upfront agency fees. For Devon county capital benchmarks and the same approach across EX1–EX4, see our{' '}
              <Link to="/locations/exeter" className="text-indigo-600 font-medium hover:underline">
                Exeter
              </Link>{' '}
              web design page.
            </p>
          </>
        )}
        {key === 'bideford' && (
          <p>
            Known as the &apos;Little White Town,&apos; Bideford is a hub for independent enterprise and maritime heritage. We specialize in building responsive, SEO-optimized websites for Bideford&apos;s unique mix of creative studios, quayside eateries, and EX39 retail businesses. By focusing on rapid load speeds and mobile-first design, we help Bideford SMEs reach customers from Victoria Park to East-the-Water, ensuring your brand remains as iconic as the Old Bridge itself.
          </p>
        )}
        {key === 'south-molton' && (
          <p>
            Serving the gateway to Exmoor, South Molton businesses thrive on community trust and regional reputation. We provide bespoke web solutions for the town&apos;s diverse agricultural, professional, and independent retail sectors. In a town famous for its historic market, having a modern digital storefront is essential. We help South Molton firms bridge the gap between traditional service and digital reach, ensuring your EX36 business is the first choice for locals and visitors alike.
          </p>
        )}
        {key === 'padstow' && (
          <p>
            In the culinary capital of Cornwall, your digital presence must match the quality of your service. Padstow businesses face a high bar; whether you are a luxury holiday let, a seafood specialist, or a boutique in the Harbour district, visitors expect a premium online experience. Our Padstow web design strategy focuses on high-conversion booking systems and stunning visual storytelling, ensuring your PL28 business remains fully booked through the summer heights and the quiet winter charm.
          </p>
        )}
        {key === 'newquay' && (
          <p>
            From the surf-culture of Fistral Beach to the growing &apos;Silicon Coast&apos; tech scene, Newquay is Cornwall&apos;s most energetic business environment. We build websites for Newquay&apos;s adventure sports providers, nightlife venues, and TR7 startups that need to move fast. With a focus on aggressive local SEO and social media integration, we ensure your Newquay business captures the &apos;Gen-Z&apos; and &apos;Millennial&apos; demographic while maintaining a professional edge that scales.
          </p>
        )}
        {key === 'st-ives' && (
          <>
            <p>
              With a global reputation for art and aesthetics, a St Ives business website must be visually flawless. From the galleries along the Down-a-Long to the high-end hospitality overlooking Porthmeor Beach, we create TR26-focused websites that reflect the unique light and style of the town. We combine &apos;Art-Gallery&apos; aesthetics with &apos;Data-Driven&apos; SEO, helping St Ives businesses attract high-net-worth visitors and maintain dominance in one of the UK&apos;s most competitive tourism markets.
            </p>
            <p>
              For Cornwall&apos;s administrative hub and county-wide search patterns, see our{' '}
              <Link to="/locations/truro" className="text-indigo-600 font-medium hover:underline">
                Truro
              </Link>{' '}
              web design page.
            </p>
          </>
        )}
      </div>
    </section>
  );
}
